export default "__VITE_ASSET__DbH8X2pe__"